import React, { Component } from 'react';
import {
	ResponsiveContainer, Tooltip, Legend, CartesianGrid, XAxis, YAxis,
	BarChart, Bar, ReferenceLine,
	Brush
} from 'recharts';
import BlockUi from 'react-block-ui';
import chartUtils, { COLORS } from '../utils';
import { withTranslation } from 'react-i18next';

class LessonPaymentsGrowthRate extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { loading, data, referenceLinesX, height = 300, t } = this.props;
		const timeSeriesChartMargin = { top: 10, right: 30, left: 0, bottom: 0 };

		return <BlockUi blocking={loading}>
			<ResponsiveContainer height={height}>
				<BarChart data={chartUtils.prepareTimeSeriesData(data)} margin={timeSeriesChartMargin}>
					<XAxis dataKey='timestamp' scale='time' type='number' domain={['dataMin', 'dataMax']} tickFormatter={unixTime => chartUtils.formatUnixTime(unixTime, 'MM/YY')} />
					<YAxis axisLine={false} tickLine={false} tickFormatter={chartUtils.formatPercentage} />
					<CartesianGrid vertical={false} />
					<Tooltip labelFormatter={label => chartUtils.formatUnixTime(label, 'll')} formatter={chartUtils.formatPercentage} />
					{referenceLinesX && data && data.length > 1 && referenceLinesX.map((line, index) => <ReferenceLine key={index} x={chartUtils.convertToUnixTime(line.value)} label={line.label} />)}
					<ReferenceLine y={0} stroke="#000" />
					<Bar name={t('SalesDashboard_GrowthRate_Rate')} dataKey='value' fill={COLORS[0]} />
					{data && data.length > 1 && <Brush height={25} />}
				</BarChart>
			</ResponsiveContainer>
		</BlockUi>;
	}
}

export default withTranslation()(LessonPaymentsGrowthRate);